export default __webpack_public_path__ + "static/media/TITULO_DISCO_12.7e1f3e1d.png";